import apiSlice from '../api/api.slice';

export interface IBannerPublic {
  _id: string;
  link?: string;
  desktopUrl: string;
  mobileUrl?: string;
  order: number;
}

const bannerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActiveBanners: builder.query<IBannerPublic[], void>({
      query: () => ({ url: '/api/v1/banner' }),
      transformResponse: (res: { banners: IBannerPublic[] }) => res.banners,
    }),
  }),
});

export const { useGetActiveBannersQuery } = bannerApiSlice;
